<ng-template>
  <gh-session-selector
    [formControl]="formControl"
    [uiId]="controlId"
    [parentItemSessionId]="parentItemSessionId"
    [a11yLabelledby]="labelId"
    [a11yRequired]="required"
    [focusMe]="autofocus"
    [borderless]="borderless"
    [a11yDescription]="ariaDescription"
    [attr.data-test-id]="e2eTestId"></gh-session-selector>
</ng-template>
